
import React from 'react';

import { BarChart, PieChart, ShowChart, ViewColumn } from '@material-ui/icons';
import { ToggleButton, ToggleButtonGroup } from '@material-ui/lab';
import {
  Chart,
  ChartCategoryAxis,
  ChartCategoryAxisItem,
  ChartCategoryAxisLabels,
  ChartLegend,
  ChartSeries,
  ChartSeriesItem,
  ChartSeriesLabels,
  ChartTitle,
  ChartTooltip
} from '@progress/kendo-react-charts';
import ToggleChart from '../dashboard/toggleview';
import CFormDropdown from '../../core/modules/form/cformdropdown';

const labelContent = (e) => (e.dataItem.share);

class KendoChart extends React.Component {

  constructor(props) {
    super(props);
    this.hoverTargetRef = React.createRef(); // Ref for the hover target
    this.toggleChartRef = React.createRef(); // Ref for the ToggleChart container
    this.state = {
      type: props.type || 'donut',
      isHovered: false
    }
  }

  componentDidMount() {
    // Add event listeners
    this.hoverTargetRef.current.addEventListener('mouseenter', this.showToggleChart);
    this.hoverTargetRef.current.addEventListener('mouseleave', this.hideToggleChart);
  }

  componentWillUnmount() {
    // Remove event listeners
    this.hoverTargetRef.current.removeEventListener('mouseenter', this.showToggleChart);
    this.hoverTargetRef.current.removeEventListener('mouseleave', this.hideToggleChart);
  }

  showToggleChart = () => {
    this.toggleChartRef.current.style.display = 'block'; // Show ToggleChart
  };

  hideToggleChart = () => {
    this.toggleChartRef.current.style.display = 'none'; // Hide ToggleChart
  };

  componentDidUpdate(prevProps) {
    if (prevProps.type !== this.props.type) {
      this.setState({ type: this.props.type })
    }
  }

  getCount = (data) => {
    let initialValue = 0;
    let total = data.reduce((accumulator, currentValue) => {
      return accumulator + (currentValue.share ? currentValue.share : 0)
    }, initialValue)
    return total
  }

  donutCenterRenderer = () => {
    const { data } = this.props;
    const total = this.getCount(data);
    return <h3>{total}</h3>
  };

  renderTooltip = (context) => {
    const { category, value } = context.point || context;
    return (
      <div>
        {category ? category : "NA"}: {value ? value : 0}%
      </div>
    );
  };

  handleType = (type) => {
    this.setState({ type: type })
  }

  handleMouseEnter = () => {
    this.setState({ isHovered: true });
  };

  handleMouseLeave = () => {
    this.setState({ isHovered: false });
  };

  isKeyIncluded = (key) => {
    const keysToCheck = ['Id', 'SubModuleKey', 'SiteId', 'SiteName', 'PermitTypeId', 'PermitName', 'StatusSettings'];

    return keysToCheck.some(keyToCheck => key.includes(keyToCheck));
  }


  render() {
    return (
      <div className="chart-container mx-1">
        <div style={{ display: 'flex', justifyContent: 'space-between' }} ref={this.hoverTargetRef}>
          <div style={{ display: 'flex', alignItems: 'center', paddingTop: this.props.hasSubType !== 'Y' ? 8 : 0 }}>
            <strong className='col-12'>{this.props.title}</strong>
            {this.props.hasSubType === 'Y' &&
                <CFormDropdown
                  size='small'
                  className='col-12'
                  label='Permit SubType'
                  value={this.state.permitypevalue || '0'}
                  dropdownvalues={this.props.permitdropdownvalues}
                  transformProps={this.props.permittransformProps}
                  handleFieldChange={this.props.handleFieldChange}
                />
            }
          </div>
          <div style={{ display: 'none' }} className="toggle-chart" ref={this.toggleChartRef}>
            <ToggleChart handleToggleView={this.handleType} type={this.state.type}/>
          </div>
        </div>
        {this.state.type !== "table" && < Chart donutCenterRender={this.donutCenterRenderer}>
          <ChartTooltip render={this.renderTooltip} />
           <ChartTitle text={this.props.name || ''} /> 
          <ChartLegend position="bottom" />
          <ChartSeries>
            <ChartSeriesItem type={this.state.type} data={this.props.data} categoryField="kind" field="share"
            >
              <ChartSeriesLabels color="#fff" background="none" //content={labelContent}
               visible={true}
               />
            </ChartSeriesItem>
          </ChartSeries>
          <ChartLegend visible={true} rotation={-45} // Rotate labels to prevent overlapping              
               /> 
               <ChartCategoryAxis>
                   <ChartCategoryAxisItem>
                       <ChartCategoryAxisLabels rotation={-45} /> {/* Rotate category axis labels */}
                   </ChartCategoryAxisItem>
               </ChartCategoryAxis>
        </Chart>}
        {this.state.type === "table" &&
          <table style={{ borderCollapse: 'collapse' }} className='col-6 mx-2'>
            <tbody>
              {this.props.item && Object.entries(this.props.item).map(([key, value], index) => (
                (!this.isKeyIncluded(key)) &&
                <tr key={index} style={{ border: '1px solid black' }}>
                  <td className='px-2' style={{ border: '1px solid black' }}>{key && key.replace(/_/g, ' ')
                    .toLowerCase()
                    .replace(/^\w/, (c) => c.toUpperCase())}</td>
                  <td className='px-2' style={{ border: '1px solid black' }}>{value}</td>
                </tr>
              ))}
            </tbody>
          </table>
        }
      </div>

    )
  }
}
//Dashboard --  My portal
export default KendoChart
